import { render, staticRenderFns } from "./BarcodeSettingsEditModal.vue?vue&type=template&id=45d405f6"
import script from "./BarcodeSettingsEditModal.vue?vue&type=script&lang=ts"
export * from "./BarcodeSettingsEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d405f6')) {
      api.createRecord('45d405f6', component.options)
    } else {
      api.reload('45d405f6', component.options)
    }
    module.hot.accept("./BarcodeSettingsEditModal.vue?vue&type=template&id=45d405f6", function () {
      api.rerender('45d405f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/BarcodeSettingsEditModal.vue"
export default component.exports